<template>
  <div
    class="flex justify-between items-start"
    :class="{
      'flex-wrap gap-x-12': sticky,
      'gap-y-24 flex-col': !sticky,
    }"
  >
    <div
      class="bg-static-default-low border border-static-default-low shrink-0"
      :class="{
        'w-[48px] p-2 lg:p-4 rounded-md': sticky,
        'p-16 rounded-lg w-full': !sticky,
      }"
    >
      <RevIllustration
        v-if="product.images?.[0]"
        :alt="product.title"
        class="w-full"
        :height="sticky ? 48 : 348"
        :sizes="sticky ? '48px' : '348px'"
        :src="product.images[0].url"
        :width="sticky ? 48 : 348"
      />
    </div>
    <div class="min-w-0 grow">
      <span
        class="text-static-default-hi"
        :class="sticky ? 'body-1-bold line-clamp-2' : 'heading-2'"
        >{{ product.title }}</span
      >
      <div v-if="product.price" data-spec="price-information">
        <div class="text-static-default-low caption">
          {{ i18n(translations.startingFrom) }}
        </div>
        <ProductPrice
          :new-price="sticky ? undefined : product.priceWhenNew"
          :price="product.price"
        />
      </div>
    </div>

    <RevButton
      :class="{ 'w-full md:w-auto mt-8 md:mt-0': sticky }"
      size="medium"
      :to="productPageUrl"
      variant="primary"
    >
      {{ i18n(translations.seeOptions) }}
    </RevButton>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { ModelComparisonCompareProduct } from '@backmarket/http-api/src/api-specs-model-comparison/models/compare-models'
import ProductPrice from '@backmarket/nuxt-layer-recommendation/ProductPrice.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { toBcp47Locale } from '@backmarket/utils/string/toBcp47Locale'
import { RevButton } from '@ds/components/Button'
import { RevIllustration } from '@ds/components/Illustration'

import { PRODUCT_ROUTES } from '~/scopes/product-core/route-names'

import translations from './ProductCard.translations'

const { product, sticky = false } = defineProps<{
  product: ModelComparisonCompareProduct
  sticky?: boolean
}>()
const i18n = useI18n()

const productPageUrl = computed(() => ({
  name: PRODUCT_ROUTES.MASTER_PRODUCT_PAGE,
  params: {
    locale: toBcp47Locale(i18n.currentLocale),
    slug: product.slug,
  },
}))
</script>
